// Croqui: `components/Pager.tsx`.

import { cn } from '../../lib/cn.ts';
import { Btn } from './btn.tsx';

/**
 * Paginação por cursor: "1 a 12 de 489" + Anterior / Próxima. Sem handler o botão fica
 * desabilitado, é como a ponta da lista se anuncia.
 */
export function Pager({
  from,
  to,
  total,
  onPrev,
  onNext,
  className,
}: {
  from: number;
  to: number;
  total: number;
  onPrev?: () => void;
  onNext?: () => void;
  className?: string;
}) {
  return (
    <div className={cn('flex items-center justify-between gap-3 pt-3', className)}>
      <span className="text-12 text-muted tabular-nums">
        {from} a {to} de {total}
      </span>
      <div className="flex gap-1.5">
        <Btn
          kind="card"
          small
          disabled={onPrev === undefined}
          {...(onPrev === undefined ? {} : { onClick: onPrev })}
        >
          Anterior
        </Btn>
        <Btn
          kind="card"
          small
          disabled={onNext === undefined}
          {...(onNext === undefined ? {} : { onClick: onNext })}
        >
          Próxima
        </Btn>
      </div>
    </div>
  );
}
